
import { defineComponent } from 'vue'
// Vuex
import { createVuexHelpers } from 'vue2-helpers'
const { useState } = createVuexHelpers()
// Types
import { IsMobileScreenState } from '@/types/storeTypes'

export default defineComponent({
	name: 'PurchaseLimitHint',

	props: {
		purchaseLimit: {
			type: Number,
			required: true
		}
	},

	setup() {
		const { isMobileScreen }: IsMobileScreenState = useState('ui', [
			'isMobileScreen'
		])

		return { isMobileScreen }
	}
})
